import { Button, Card, Input, Space, Table } from 'antd';
import React, { useRef, useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';

const ReportTable = ({loading, reports, highlighted, handleRowOnClick}) => {
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
  
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
    };
  
    const handleReset = (clearFilters) => {
      clearFilters();
      setSearchText('');
    };
  
    const getColumnSearchProps = (dataIndex) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              Search
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters)}
              size="small"
              style={{
                width: 90,
              }}
            >
              Reset
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                confirm({
                  closeDropdown: false,
                });
                setSearchText(selectedKeys[0]);
                setSearchedColumn(dataIndex);
              }}
            >
              Filter
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                close();
              }}
            >
              Close
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{
            color: filtered ? '#1677ff' : undefined,
          }}
        />
      ),
      onFilter: (value, record) =>
        record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
      render: (text) =>
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        ),
    });

    const columns = [
        {
            title: "IFSP #",
            key: "ifspNumber",
            dataIndex: "ifspNumber",
            ...getColumnSearchProps('ifspNumber'),
            sorter: (a, b) => a.ifspNumber.localCompare(b.ifspNumber),
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: "Name",
            key: "name",
            dataIndex: "name",
            ...getColumnSearchProps('name'),
            sorter: (a, b) => a.name.localCompare(b.name),
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: "IFSP Date",
            key: "ifspDate",
            dataIndex: "ifspDate",
            ...getColumnSearchProps('ifspDate'),
            sorter: (a, b) => a.ifspDate.localCompare(b.ifspDate),
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: "Therapists",
            key: "therapists",
            dataIndex: "therapists",
            render: (list) => list?.join(", "),
            ...getColumnSearchProps('therapists'),
            sorter: (a, b) => a.therapists.localCompare(b.therapists),
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: "Month Report Due",
            key: "monthsDue",
            dataIndex: "monthsDue",
            render: (list) => list?.join(", "),
            ...getColumnSearchProps('monthsDue'),
            sorter: (a, b) => a.monthsDue.localCompare(b.monthsDue),
            sortDirections: ['descend', 'ascend'],
        }
    ];


    return (
        <Card style={{ height: "100%" }} size="small">
            <Table 
                pagination={false}
                loading={loading}
                dataSource={reports}
                columns={columns}
                rowKey={(record) => record.ifspNumber}
                rowClassName={record => (highlighted === record ? 'ant-table-row-selected' : '')}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: e => handleRowOnClick(record)
                    }
                }}
                scroll={{
                  x: 'max-content',
                  y: 500
                }}
            />
        </Card>
    );
};

export default ReportTable;